import React from 'react'

import {
  ButtonAppearance,
  isButtonAppearanceGhost,
  isButtonAppearanceSecondary,
} from '../../../../../global/button/Button'

type ButtonType = {
  size?: string
  type?: string
  fullWidth: true
  appearance?: string
}

export const isButtonValid = (
  button: React.ReactNode
): button is React.ReactElement<ButtonType> => {
  return React.isValidElement<ButtonType>(button)
}

export const cloneButtonMobile = (button: React.ReactNode): React.ReactNode => {
  return (
    isButtonValid(button) &&
    React.cloneElement(button, {
      appearance: getButtonAppearanceMobile(button.props.appearance),
      size: 'M',
      type: 'button',
      fullWidth: true,
    })
  )
}

export const cloneButtonLarge = (button: React.ReactNode): React.ReactNode => {
  return (
    isButtonValid(button) &&
    React.cloneElement(button, {
      size: 'L',
      type: 'button',
      fullWidth: true,
    })
  )
}

export const cloneButtonBottomSheet = (button: React.ReactNode): React.ReactNode => {
  return (
    isButtonValid(button) &&
    React.cloneElement(button, {
      appearance: getButtonAppearanceMobile(button.props.appearance),
      size: 'S',
      type: 'button',
    })
  )
}

export const cloneButtonDesktop = (button: React.ReactNode): React.ReactNode => {
  return (
    isButtonValid(button) &&
    React.cloneElement(button, {
      appearance: getButtonAppearanceDesktop(button.props.appearance),
      size: 'S',
      type: 'button',
    })
  )
}

export const getButtonAppearanceMobile = (appearance?: string): string | undefined => {
  return isButtonAppearanceSecondary(appearance) || isButtonAppearanceGhost(appearance)
    ? ButtonAppearance.Secondary
    : appearance
}

export const getButtonAppearanceDesktop = (appearance?: string): string | undefined => {
  return isButtonAppearanceSecondary(appearance) || isButtonAppearanceGhost(appearance)
    ? ButtonAppearance.Ghost
    : appearance
}

export function getSortedButtons<T extends { renderFooter?: (props: T) => React.ReactNode[] }>(
  props: T,
  fallbackRender: React.ReactNode[]
): React.ReactNode[] {
  if (props.renderFooter) {
    return [...props.renderFooter(props)].reverse()
  } else {
    return fallbackRender
  }
}
